import { ServicesStatus } from '@fcom/dapi';
import { CommonBookingState } from './store.interface';

export const ANCILLARY_TEST_STATE_FIXTURE: CommonBookingState = {
  services: {
    status: ServicesStatus.OK,
    selections: {},
    services: {
      messages: [],
      categories: [],
      campaigns: [],
      paxLevelQuota: {
        combinedQuota: 0,
        variants: [],
      },
    },
    campaignsShown: [],
  },
};
